<!--
@Author: MIYONGLE
@Desc: 关于我们 - 加入我们
@Date: 2021-07-29 13时
-->
<template>
  <div>
    <!-- 社会招聘 -->
    <span class="title-text">社会招聘</span>

    <!-- 社会招聘 -->
    <div class="mJoinUs-con">
      <div v-for="(item,index) of listArr" :key="index">

        <div class="mJoinUs-con-line">
          <img :src="item.src" alt="慧用工">
          <span>{{item.title}}</span>
        </div>

        <van-collapse v-model="activeNames" accordion 
          v-for="(itemSon,index) of item.children" :key="index">
          <van-collapse-item :title="itemSon.title" :name='itemSon.name'>
            <template #right-icon>
              <van-icon :name="activeNames == itemSon.name ? 'cross' : 'plus'" />
            </template>
            <span v-html="itemSon.desc"></span>
            <span class="email-con">投递邮箱：geyaru@hvyogo.com</span>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>

    <!-- 发送邮箱 -->
    <div class="email-con-fasong">

      <div class="email-con-text">
        <span>简历发至招聘邮箱<br>geyaru@hvyogo.com</span>
        <span>HR团队将在收到简历的5个工作日内进行处理。若简历通过，您将立即收到通知。</span>
      </div>

      <img src="../../../static/mobile/aboutUs/aboutus_icon_mail (1).png" alt="" class="email-con-img">

    </div>


  </div>
</template>

<script type="text/javascript">
import {JOIN_US_CONST} from '../../service/businessConsts'
export default {
  name: "mJoin-us",
  data() {
    return {
      activeNames: [''],
      listArr: JOIN_US_CONST
    }
  },
  components: {
  },
  created() {
  },
  methods: {
  }
}
</script>

<style>
.mJoinUs-con .van-cell{
  padding: 0;
  display: flex;
  justify-content: space-between;
  height: 125px;
  line-height: 125px;
  background: #FBFDFF;
}

.mJoinUs-con .van-cell__title{
  text-align: left;
  color: #100F0F;
  font-size: 28px;
}

.mJoinUs-con [class*=van-hairline]::after{
  border-bottom:1px solid #CFCFCF ;
}

.mJoinUs-con .van-collapse-item__content{
  background: #F4F4F4;
  padding: 56px 30px;
  box-sizing: border-box;
  color: #171E2E;
  font-size: 26px;
  line-height: 46px;
  text-align: left;
  display: block;
  overflow: hidden;
  text-size-adjust: none;
  -webkit-text-size-adjust: none;
  text-align: justify;
  border-top: 1px solid #CFCFCF;
}

.mJoinUs-con .van-icon{
  font-size: 38px;
  margin-top: 50px;
  color: rgba(23, 23, 23, 1)
}


</style>

<style lang="scss" scoped>
  //标题
  .title-text{
    margin-top: 103px;
    display: block;
    font-size: 40px;
    font-weight: 600;
    color: #100F0F;
  }

  // 内容
  .mJoinUs-con{
    margin-top: 53px;
    padding: 0 30px;
    box-sizing: border-box;
    .mJoinUs-con-line{
      text-align: left;
      height: 125px;
      line-height: 125px;
      border-bottom: 1px solid #CFCFCF;
      img{
        width: 50px;
        height: 50px;
        position: relative;
        top: 10px;
      }
      span{
        font-size: 36px;
        font-weight: 500;
        color: #100F0F;
        margin-left: 10px;
        font-weight: 500;
      }
    }
  }

  .email-con{
    width: 630px;
    height: 80px;
    background: #1985FF;
    border-radius: 40px;
    height: 80px;
    display: block;
    color: #fff;
    text-align: center;
    line-height: 80px;
    margin-top: 56px;
    font-size: 30px;
  }

  // 发送邮箱
  .email-con-fasong{
    width: 100%;
    height: 264px;
    background: linear-gradient(180deg, rgba(25, 133, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%);
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
    margin-top: 117px;
    .email-con-text span{
      text-align: left;
      line-height: 38px;
      font-size: 28px;
      display: block;
    }

    span:nth-child(1){
      color: #100F0F;
      margin-top: 55px;
    }

    span:nth-child(2){
      color: #9F9F9F;
      margin-top: 19px;
      font-size: 22px;
    }

    .email-con-img{
      width: 202px;
      height: 202px;
      margin-top: 30px;
    }
  }

</style>


// WEBPACK FOOTER //
// src/views/mobile/mJoinUs_aboutUser.vue